export default __webpack_public_path__ + "static/media/post.cef64c59.png";